import { defineComponent as I, computed as e, createBlock as T, openBlock as l, resolveDynamicComponent as a, defineAsyncComponent as d } from "vue";
const u = /* @__PURE__ */ I({
  __name: "TnIcon",
  props: {
    name: {},
    color: { default: "currentColor" },
    size: { default: "m" }
  },
  setup(p) {
    const o = p, t = e(() => o.size === "xs" ? "16px" : o.size === "s" ? "20px" : o.size === "m" ? "22px" : o.size === "l" ? "26px" : o.size === "xl" ? "28px" : o.size === "2xl" ? "32px" : "22px");
    function n(i) {
      return d({
        loader: i,
        suspensible: !1,
        onError() {
        }
      });
    }
    const r = {
      TnIcon0: n(() => import("./TnIcon0-kj7qLs6-.js")),
      TnIcon0Filled: n(() => import("./TnIcon0-filled-BT62tN3O.js")),
      TnIcon0Outline: n(() => import("./TnIcon0-outline-uoLcI3U4.js")),
      TnIcon1: n(() => import("./TnIcon1-Dy4PHRCG.js")),
      TnIcon1Filled: n(() => import("./TnIcon1-filled-CtRUxow7.js")),
      TnIcon1Outline: n(() => import("./TnIcon1-outline-4VlbkbHK.js")),
      TnIcon2: n(() => import("./TnIcon2-5P3qqoZk.js")),
      TnIcon2Filled: n(() => import("./TnIcon2-filled-eQZKyaga.js")),
      TnIcon2Outline: n(() => import("./TnIcon2-outline-BuMZ2Z-t.js")),
      TnIcon3: n(() => import("./TnIcon3-BGzis1Ma.js")),
      TnIcon3Filled: n(() => import("./TnIcon3-filled-DIsiS_79.js")),
      TnIcon3Outline: n(() => import("./TnIcon3-outline-p0o1YXmq.js")),
      TnIcon4: n(() => import("./TnIcon4-BL2QA9Pa.js")),
      TnIcon4Filled: n(() => import("./TnIcon4-filled-RjRcW5ar.js")),
      TnIcon4Outline: n(() => import("./TnIcon4-outline-BEfplgnl.js")),
      TnIcon5: n(() => import("./TnIcon5-BDkZ8xod.js")),
      TnIcon5Filled: n(() => import("./TnIcon5-filled-D197TISR.js")),
      TnIcon5Outline: n(() => import("./TnIcon5-outline-IOIbDp27.js")),
      TnIcon6: n(() => import("./TnIcon6-BglGo8Pb.js")),
      TnIcon60DayFreeReturns: n(() => import("./TnIcon60-day-free-returns-BOC5t7YR.js")),
      TnIcon6Filled: n(() => import("./TnIcon6-filled-CKfmutcG.js")),
      TnIcon6Outline: n(() => import("./TnIcon6-outline-BPJG3z3V.js")),
      TnIcon7: n(() => import("./TnIcon7-B8vemfhd.js")),
      TnIcon7Filled: n(() => import("./TnIcon7-filled-CZxVJW4i.js")),
      TnIcon7Outline: n(() => import("./TnIcon7-outline-dLhrHpEf.js")),
      TnIcon8: n(() => import("./TnIcon8-DZ77uBhR.js")),
      TnIcon8Filled: n(() => import("./TnIcon8-filled-DDaR2yRL.js")),
      TnIcon8Outline: n(() => import("./TnIcon8-outline-wkXUm-lF.js")),
      TnIcon9: n(() => import("./TnIcon9-BSjNYW_x.js")),
      TnIcon9Filled: n(() => import("./TnIcon9-filled-B8dR3j1k.js")),
      TnIcon9Outline: n(() => import("./TnIcon9-outline-DIaklnK4.js")),
      TnIconAccount: n(() => import("./TnIconaccount-DHe2cYQh.js")),
      TnIconAI: n(() => import("./TnIconai-4jzl7Cmo.js")),
      TnIconAIFilled: n(() => import("./TnIconai-filled-B51f7ktk.js")),
      TnIconAIOutline: n(() => import("./TnIconai-outline-T9qiM32b.js")),
      TnIconAISymbol: n(() => import("./TnIconai-symbol-DC0niIzZ.js")),
      TnIconAISymbolFilled: n(() => import("./TnIconai-symbol-filled-BX8G8Wju.js")),
      TnIconAltRoute: n(() => import("./TnIconalt-route-DKA9R7Fv.js")),
      TnIconAntenna: n(() => import("./TnIconantenna-BiKdmF-G.js")),
      TnIconAppleAirplay: n(() => import("./TnIconapple-airplay-CDrk04dE.js")),
      TnIconApps: n(() => import("./TnIconapps-CiLdyaBv.js")),
      TnIconAt: n(() => import("./TnIconat-CSSXIhnV.js")),
      TnIconAttentionCircleFilled: n(() => import("./TnIconattention-circle-filled-BtUUmWTu.js")),
      TnIconAttentionCircleFlat: n(() => import("./TnIconattention-circle-flat-Cggrp9V4.js")),
      TnIconAttentionCircleOutline: n(() => import("./TnIconattention-circle-outline-BMFYlSL0.js")),
      TnIconBackspace: n(() => import("./TnIconbackspace-rUCPJUMt.js")),
      TnIconBackspaceFilled: n(() => import("./TnIconbackspace-filled-C619yYej.js")),
      TnIconBankID: n(() => import("./TnIconbank-id-DhpYH4g-.js")),
      TnIconBankIDApp: n(() => import("./TnIconbank-id-app-DAIXElZe.js")),
      TnIconBankIDAppNegative: n(() => import("./TnIconbank-id-app-negative-C1LuQxLr.js")),
      TnIconBatteryCharging: n(() => import("./TnIconbattery-charging-Pd_1JdL0.js")),
      TnIconBatteryEmpty: n(() => import("./TnIconbattery-empty-oeOs0ly3.js")),
      TnIconBatteryFull: n(() => import("./TnIconbattery-full-CDUwyL6b.js")),
      TnIconBatteryHalf: n(() => import("./TnIconbattery-half-CT4D5fKl.js")),
      TnIconBatteryLow: n(() => import("./TnIconbattery-low-DnuYSKNq.js")),
      TnIconBatteryQuarter: n(() => import("./TnIconbattery-quarter-OE030qVM.js")),
      TnIconBills: n(() => import("./TnIconbills-IufFw9bz.js")),
      TnIconBookmarkFilled: n(() => import("./TnIconbookmark-filled-cHIG-7yk.js")),
      TnIconBookmarkOutline: n(() => import("./TnIconbookmark-outline-CgpdPNIz.js")),
      TnIconBookmarks: n(() => import("./TnIconbookmarks-4c_J741Y.js")),
      TnIconBranch: n(() => import("./TnIconbranch-D1kjrpru.js")),
      TnIconBullet: n(() => import("./TnIconbullet-ycwhEDRQ.js")),
      TnIconBulletOutline: n(() => import("./TnIconbullet-outline-BOlIlgU6.js")),
      TnIconBullhorn: n(() => import("./TnIconbullhorn-DDi-RUI6.js")),
      TnIconBusiness: n(() => import("./TnIconbusiness-Dah5klJU.js")),
      TnIconCalendar: n(() => import("./TnIconcalendar-QS_AFyJb.js")),
      TnIconCallEnd: n(() => import("./TnIconcall-end-CNDlEwhi.js")),
      TnIconCallForwarded: n(() => import("./TnIconcall-forwarded-DsmcY2xz.js")),
      TnIconCallForwardedFilled: n(() => import("./TnIconcall-forwarded-filled-D6b1u0CY.js")),
      TnIconCallIncoming: n(() => import("./TnIconcall-incoming-Ceh4-Dal.js")),
      TnIconCallIncomingFilled: n(() => import("./TnIconcall-incoming-filled-DARuDUvw.js")),
      TnIconCallInUse: n(() => import("./TnIconcall-in-use-BnejEbih.js")),
      TnIconCallInUseFilled: n(() => import("./TnIconcall-in-use-filled-IapCyT5R.js")),
      TnIconCallMissed: n(() => import("./TnIconcall-missed-3SWIp6y1.js")),
      TnIconCallMissedFilled: n(() => import("./TnIconcall-missed-filled-gubZAG7_.js")),
      TnIconCallOff: n(() => import("./TnIconcall-off-BZL4OtKc.js")),
      TnIconCallOffFilled: n(() => import("./TnIconcall-off-filled-jdAn6dR8.js")),
      TnIconCallOutgoing: n(() => import("./TnIconcall-outgoing-C6TqkOlE.js")),
      TnIconCallOutgoingFilled: n(() => import("./TnIconcall-outgoing-filled-CMkienKr.js")),
      TnIconCallPause: n(() => import("./TnIconcall-pause-DaLUtM5E.js")),
      TnIconCallPauseFilled: n(() => import("./TnIconcall-pause-filled-BqZN9hjE.js")),
      TnIconCamera: n(() => import("./TnIconcamera-hWRTWz6j.js")),
      TnIconCart: n(() => import("./TnIconcart-CYXAm_QK.js")),
      TnIconCartNewItem: n(() => import("./TnIconcart-new-item-C_QqnF5t.js")),
      TnIconCatchUp: n(() => import("./TnIconcatch-up-CzmrmI91.js")),
      TnIconChart: n(() => import("./TnIconchart-CB0oH8qL.js")),
      TnIconCheckboxChecked: n(() => import("./TnIconcheckbox-checked-CtmLk8x0.js")),
      TnIconCheckboxUnchecked: n(() => import("./TnIconcheckbox-unchecked-LgwcHNom.js")),
      TnIconChevronDown: n(() => import("./TnIconchevron-down-dTbZzf-D.js")),
      TnIconChevronLeft: n(() => import("./TnIconchevron-left-BaFH7_Ym.js")),
      TnIconChevronRight: n(() => import("./TnIconchevron-right-BOmHTjUp.js")),
      TnIconChevronsDown: n(() => import("./TnIconchevrons-down-DJ0NKfuk.js")),
      TnIconChevronsLeft: n(() => import("./TnIconchevrons-left-CnitPiCC.js")),
      TnIconChevronsRight: n(() => import("./TnIconchevrons-right-CLl6Stqa.js")),
      TnIconChevronsUp: n(() => import("./TnIconchevrons-up-UkS4YbL9.js")),
      TnIconChevronUp: n(() => import("./TnIconchevron-up-BRPq3VAu.js")),
      TnIconChild1: n(() => import("./TnIconchild1-XBztFmjn.js")),
      TnIconChild2: n(() => import("./TnIconchild2-BLwiOMp8.js")),
      TnIconChromecastOff: n(() => import("./TnIconchromecast-off-B5h4jGZ8.js")),
      TnIconChromecastOn: n(() => import("./TnIconchromecast-on-DtHzHDHY.js")),
      TnIconClock: n(() => import("./TnIconclock-Dui8ESH9.js")),
      TnIconClose: n(() => import("./TnIconclose-B5gJ6gbN.js")),
      TnIconClosePanelLeft: n(() => import("./TnIconclose-panel-left-5WU4f0bZ.js")),
      TnIconClosePanelRight: n(() => import("./TnIconclose-panel-right-5MtNLXxX.js")),
      TnIconCloudDownload: n(() => import("./TnIconcloud-download-CyNeh5-3.js")),
      TnIconCloudUpload: n(() => import("./TnIconcloud-upload-DjnCobwp.js")),
      TnIconCode: n(() => import("./TnIconcode-C9WvVqvS.js")),
      TnIconCoins: n(() => import("./TnIconcoins-BmdGlXL9.js")),
      TnIconCollapse: n(() => import("./TnIconcollapse-DBiSuIbK.js")),
      TnIconConnected: n(() => import("./TnIconconnected-CwlkYujL.js")),
      TnIconContentSwitcher: n(() => import("./TnIconcontent-switcher-tz2Wnkcq.js")),
      TnIconContractScreen: n(() => import("./TnIconcontract-screen-C1XgfSns.js")),
      TnIconCookie: n(() => import("./TnIconcookie-CZcFPfw8.js")),
      TnIconCopy: n(() => import("./TnIconcopy-DW_4pAuH.js")),
      TnIconCreditCard: n(() => import("./TnIconcredit-card-CeDvscgN.js")),
      TnIconCriticalFilled: n(() => import("./TnIconcritical-filled-DOxpm7ZE.js")),
      TnIconCriticalFilledFlat: n(() => import("./TnIconcritical-filled-flat-CYH9fqZJ.js")),
      TnIconCriticalOutline: n(() => import("./TnIconcritical-outline-Cy3sP6j6.js")),
      TnIconCtaLeft: n(() => import("./TnIconcta-left-BhPqu5Mw.js")),
      TnIconCtaRight: n(() => import("./TnIconcta-right-C16ZOLR1.js")),
      TnIconCustomerService: n(() => import("./TnIconcustomer-service-C0ezAtVp.js")),
      TnIconDarkMode: n(() => import("./TnIcondark-mode-CLbtUsvR.js")),
      TnIconDarkModeFilled: n(() => import("./TnIcondark-mode-filled-B-iyLp1b.js")),
      TnIconDashboard: n(() => import("./TnIcondashboard-gqpqfWrH.js")),
      TnIconDelete: n(() => import("./TnIcondelete-Cc0KYmdD.js")),
      TnIconDeleteFilled: n(() => import("./TnIcondelete-filled-B1nGiHGu.js")),
      TnIconDelivery: n(() => import("./TnIcondelivery-B1VV4a8H.js")),
      TnIconDeliveryExpress: n(() => import("./TnIcondelivery-express-DOG_AFfk.js")),
      TnIconDevices: n(() => import("./TnIcondevices-BvOw-mlA.js")),
      TnIconDiagonalDownLeft: n(() => import("./TnIcondiagonal-down-left-DLT6_Ija.js")),
      TnIconDiagonalDownRight: n(() => import("./TnIcondiagonal-down-right-CLJ9QlAZ.js")),
      TnIconDiagonalUpLeft: n(() => import("./TnIcondiagonal-up-left-DSPUkpSZ.js")),
      TnIconDiagonalUpRight: n(() => import("./TnIcondiagonal-up-right-BGyI_ZfD.js")),
      TnIconDiscount: n(() => import("./TnIcondiscount-zNC1DP9e.js")),
      TnIconDocument: n(() => import("./TnIcondocument-BAeqaKyi.js")),
      TnIconDocumentAdd: n(() => import("./TnIcondocument-add-DkUEPhIY.js")),
      TnIconDocumentDelete: n(() => import("./TnIcondocument-delete-Dd-BBbCc.js")),
      TnIconDocumentDetails: n(() => import("./TnIcondocument-details-C9874oRw.js")),
      TnIconDolbyDigital: n(() => import("./TnIcondolby-digital-BUtFdNqs.js")),
      TnIconDown: n(() => import("./TnIcondown-BsiKci4o.js")),
      TnIconDownloadCircle: n(() => import("./TnIcondownload-circle-DhBYBRYe.js")),
      TnIconDownloadCompleteTray: n(() => import("./TnIcondownload-complete-tray-Dv-88dPB.js")),
      TnIconDownloadProgressCircle: n(() => import("./TnIcondownload-progress-circle-CGsIE56M.js")),
      TnIconDownloadToBox: n(() => import("./TnIcondownload-to-box-n5QV2j_S.js")),
      TnIconDownloadTray: n(() => import("./TnIcondownload-tray-CpNY2aDl.js")),
      TnIconDragDots: n(() => import("./TnIcondrag-dots-BqguGqVz.js")),
      TnIconDragHandleHorisontal: n(() => import("./TnIcondrag-handle-horisontal-CKIJp9k2.js")),
      TnIconDragHandleVertical: n(() => import("./TnIcondrag-handle-vertical-CyEzuRGe.js")),
      TnIconEdit: n(() => import("./TnIconedit-BeQe1fdx.js")),
      TnIconEmail: n(() => import("./TnIconemail-kBAJTQvx.js")),
      TnIconEmployee: n(() => import("./TnIconemployee-eVXMGwMz.js")),
      TnIconErrorCircleFilled: n(() => import("./TnIconerror-circle-filled-BORRAY6a.js")),
      TnIconErrorCircleFlat: n(() => import("./TnIconerror-circle-flat-DiC76WAm.js")),
      TnIconErrorCircleOutline: n(() => import("./TnIconerror-circle-outline-D7O-xkfG.js")),
      TnIconeSim: n(() => import("./TnIcone-sim-qJLK5Y9E.js")),
      TnIconEthernet: n(() => import("./TnIconethernet-DnsuLmRI.js")),
      TnIconExpand: n(() => import("./TnIconexpand-DHg73leg.js")),
      TnIconExpandInputBox: n(() => import("./TnIconexpand-input-box-DaOdX-bb.js")),
      TnIconExpandScreen: n(() => import("./TnIconexpand-screen-DcTPL5J-.js")),
      TnIconExpressDelivery: n(() => import("./TnIconexpress-delivery-CrjD163g.js")),
      TnIconExternalLink: n(() => import("./TnIconexternal-link-CkC8_5xy.js")),
      TnIconEyeClosed: n(() => import("./TnIconeye-closed-DLVlWSCs.js")),
      TnIconEyeOff: n(() => import("./TnIconeye-off-B1oyE30u.js")),
      TnIconEyeOpen: n(() => import("./TnIconeye-open-CeVQq1kg.js")),
      TnIconFacebook: n(() => import("./TnIconfacebook-C9tjVyo0.js")),
      TnIconFaceDissatisfied: n(() => import("./TnIconface-dissatisfied-CsgNTJNf.js")),
      TnIconFaceDissatisfiedFilled: n(() => import("./TnIconface-dissatisfied-filled-CUm6kI7n.js")),
      TnIconFaceHappy: n(() => import("./TnIconface-happy-B6NpWKfC.js")),
      TnIconFaceHappyFilled: n(() => import("./TnIconface-happy-filled-vAqg3xWS.js")),
      TnIconFaceID: n(() => import("./TnIconface-id-DIGlB537.js")),
      TnIconFaceNeutral: n(() => import("./TnIconface-neutral-52iT303P.js")),
      TnIconFaceNeutralFilled: n(() => import("./TnIconface-neutral-filled-j6ssJBTq.js")),
      TnIconFaceSatisfied: n(() => import("./TnIconface-satisfied-C-3m9lXJ.js")),
      TnIconFaceSatisfiedFilled: n(() => import("./TnIconface-satisfied-filled-Dk0XJMBL.js")),
      TnIconFaceUnhappy: n(() => import("./TnIconface-unhappy-BJwHy4u5.js")),
      TnIconFaceUnhappyFilled: n(() => import("./TnIconface-unhappy-filled-BJRYmQZy.js")),
      TnIconFamily: n(() => import("./TnIconfamily-z9xbedVj.js")),
      TnIconFiber: n(() => import("./TnIconfiber-D4ofEAD6.js")),
      TnIconFigma: n(() => import("./TnIconfigma-DKLfbpiR.js")),
      TnIconFigmaOutline: n(() => import("./TnIconfigma-outline-BWZYy3np.js")),
      TnIconFilter: n(() => import("./TnIconfilter-DWfD4EPD.js")),
      TnIconFingerprint: n(() => import("./TnIconfingerprint-aFHtVb48.js")),
      TnIconFlagFilled: n(() => import("./TnIconflag-filled-uIAYP4Zz.js")),
      TnIconFlagOutline: n(() => import("./TnIconflag-outline-BeGVUNMZ.js")),
      TnIconFloppy: n(() => import("./TnIconfloppy-Doabxww9.js")),
      TnIconFolder: n(() => import("./TnIconfolder-CLOHLLO8.js")),
      TnIconFolderAdd: n(() => import("./TnIconfolder-add-DUhRPjoA.js")),
      TnIconFolders: n(() => import("./TnIconfolders-C5eHIZUb.js")),
      TnIconFreeDeliveryAndReturns: n(() => import("./TnIconfree-delivery-and-returns-DJJ5sJLe.js")),
      TnIconFullScreen: n(() => import("./TnIconfull-screen-DA5RaKdo.js")),
      TnIconGenre: n(() => import("./TnIcongenre-By4Aco_C.js")),
      TnIconGift: n(() => import("./TnIcongift-DFFOjRMO.js")),
      TnIconGithub: n(() => import("./TnIcongithub-Bw2-b7-s.js")),
      TnIconGlobe: n(() => import("./TnIconglobe-CdJ2gTvC.js")),
      TnIconGraph: n(() => import("./TnIcongraph-DkvCSvZ6.js")),
      TnIconHardOfHearing: n(() => import("./TnIconhard-of-hearing-BbGfAnxa.js")),
      TnIconHeartFilled: n(() => import("./TnIconheart-filled-aaaIpKXo.js")),
      TnIconHeartOutline: n(() => import("./TnIconheart-outline-CMV7jc29.js")),
      TnIconHelp: n(() => import("./TnIconhelp--OVTEucZ.js")),
      TnIconHistory: n(() => import("./TnIconhistory-X6aWmoO1.js")),
      TnIconHome: n(() => import("./TnIconhome-CSaXLxZN.js")),
      TnIconHourglass: n(() => import("./TnIconhourglass-CXDSquXJ.js")),
      TnIconHourglassFinished: n(() => import("./TnIconhourglass-finished-CGVYugUn.js")),
      TnIconHourglassRunning: n(() => import("./TnIconhourglass-running-UlD33ba1.js")),
      TnIconInfinity: n(() => import("./TnIconinfinity-dOcxr4FS.js")),
      TnIconInfoCircleFilled: n(() => import("./TnIconinfo-circle-filled-OT0gnRzE.js")),
      TnIconInfoCircleFlat: n(() => import("./TnIconinfo-circle-flat-DLurQBxG.js")),
      TnIconInfoCircleOutline: n(() => import("./TnIconinfo-circle-outline-BgIqfeP9.js")),
      TnIconInfoStandalone: n(() => import("./TnIconinfo-standalone-CyXDkX67.js")),
      TnIconInstagram: n(() => import("./TnIconinstagram-wjHgHetg.js")),
      TnIconInvoice: n(() => import("./TnIconinvoice-LGbssiHf.js")),
      TnIconInvoiceAccount: n(() => import("./TnIconinvoice-account-Bvuwuy4I.js")),
      TnIconIoTSim: n(() => import("./TnIconio-t-sim-Bm0HZjo5.js")),
      TnIconKey: n(() => import("./TnIconkey-BtERCFsB.js")),
      TnIconKeypad: n(() => import("./TnIconkeypad-y8Z2OgAF.js")),
      TnIconKI: n(() => import("./TnIconki-BTzhl7TQ.js")),
      TnIconKIFilled: n(() => import("./TnIconki-filled-CT8e5qOr.js")),
      TnIconKIOutline: n(() => import("./TnIconki-outline-n7vHjuhz.js")),
      TnIconKISymbolOutline: n(() => import("./TnIconki-symbol-outline-B_USrMJD.js")),
      TnIconKroner: n(() => import("./TnIconkroner-DnjtXqRZ.js")),
      TnIconLan: n(() => import("./TnIconlan-C7xtdAR5.js")),
      TnIconLaptop: n(() => import("./TnIconlaptop-BQ0KZm4d.js")),
      TnIconLeft: n(() => import("./TnIconleft-f-jN1JqL.js")),
      TnIconLightbulb: n(() => import("./TnIconlightbulb-FGFXl1Jd.js")),
      TnIconLightMode: n(() => import("./TnIconlight-mode-xlJTH4VB.js")),
      TnIconLightModeFilled: n(() => import("./TnIconlight-mode-filled-BZYgeqtV.js")),
      TnIconLightningFilled: n(() => import("./TnIconlightning-filled-DONKebct.js")),
      TnIconLightningFilledwithOutline: n(() => import("./TnIconlightning-filledwith-outline-Dkv66Ml9.js")),
      TnIconLightningOutline: n(() => import("./TnIconlightning-outline-SrlRERl_.js")),
      TnIconLink: n(() => import("./TnIconlink-DDEndn1W.js")),
      TnIconLink2: n(() => import("./TnIconlink2-D9y3CNt4.js")),
      TnIconLinkedIn: n(() => import("./TnIconlinked-in-djJD7cfa.js")),
      TnIconLive: n(() => import("./TnIconlive-C3pPMa7t.js")),
      TnIconLocation: n(() => import("./TnIconlocation-XNGUuFWF.js")),
      TnIconLocationFilled: n(() => import("./TnIconlocation-filled-CNxZeWRW.js")),
      TnIconLocationFilledwithOutline: n(() => import("./TnIconlocation-filledwith-outline-RgkCR1U_.js")),
      TnIconLockFilledClosed: n(() => import("./TnIconlock-filled-closed-MT4CtJLi.js")),
      TnIconLockFilledOpen: n(() => import("./TnIconlock-filled-open-Dk2vDzAw.js")),
      TnIconLockOutlineClosed: n(() => import("./TnIconlock-outline-closed-DUEE6lrr.js")),
      TnIconLockOutlineOpen: n(() => import("./TnIconlock-outline-open-BEoBkdJd.js")),
      TnIconLog: n(() => import("./TnIconlog-A-UpnrNu.js")),
      TnIconLogIn: n(() => import("./TnIconlog-in-DLFX1oQN.js")),
      TnIconLogOut: n(() => import("./TnIconlog-out-DM-QeJ87.js")),
      TnIconLongDown: n(() => import("./TnIconlong-down-Sdk-_GMS.js")),
      TnIconLongLeft: n(() => import("./TnIconlong-left-_pxi-jBy.js")),
      TnIconLongRight: n(() => import("./TnIconlong-right-cIkBFGDY.js")),
      TnIconLongUp: n(() => import("./TnIconlong-up-BMxz1US2.js")),
      TnIconMaximise: n(() => import("./TnIconmaximise-CVm9k8pE.js")),
      TnIconMBN: n(() => import("./TnIconmbn-DigJP4gw.js")),
      TnIconMegaphone: n(() => import("./TnIconmegaphone-LkxpE9uy.js")),
      TnIconMenu: n(() => import("./TnIconmenu-AcVglONP.js")),
      TnIconMessage: n(() => import("./TnIconmessage-DuxrHspT.js")),
      TnIconMicrophoneOff: n(() => import("./TnIconmicrophone-off-Df7iizw7.js")),
      TnIconMicrophoneOn: n(() => import("./TnIconmicrophone-on-BntTjFSS.js")),
      TnIconMicrosoftOffice: n(() => import("./TnIconmicrosoft-office-C4Ew82V0.js")),
      TnIconMinimise: n(() => import("./TnIconminimise-BkWo_vXD.js")),
      TnIconMinus: n(() => import("./TnIconminus-DeNPtkZU.js")),
      TnIconMinusCircleFilled: n(() => import("./TnIconminus-circle-filled-DKe9eFq3.js")),
      TnIconMinusCircleOutline: n(() => import("./TnIconminus-circle-outline-CFaLmkyT.js")),
      TnIconMonitor: n(() => import("./TnIconmonitor-Bb3SKpp-.js")),
      TnIconMovieArchive: n(() => import("./TnIconmovie-archive-DMuJQY2U.js")),
      TnIconMovieClip: n(() => import("./TnIconmovie-clip-vCWouFCS.js")),
      TnIconMovies: n(() => import("./TnIconmovies-DuPM_WLg.js")),
      TnIconMusic: n(() => import("./TnIconmusic-BvoAQUJd.js")),
      TnIconNearMeOff: n(() => import("./TnIconnear-me-off-DmtrbY99.js")),
      TnIconNearMeOn: n(() => import("./TnIconnear-me-on-B6bXvy5O.js")),
      TnIconNoBinding: n(() => import("./TnIconno-binding-CEMv1Cww.js")),
      TnIconNotificationFilled: n(() => import("./TnIconnotification-filled-U8qOktfC.js")),
      TnIconNotificationNew: n(() => import("./TnIconnotification-new-CaKSuWzl.js")),
      TnIconNotificationNone: n(() => import("./TnIconnotification-none-DTowJnx1.js")),
      TnIconOpeninnewWindow: n(() => import("./TnIconopeninnew-window-Ds3NkHzm.js")),
      TnIconOpenPanelLeft: n(() => import("./TnIconopen-panel-left-DE8SWtB3.js")),
      TnIconOpenPanelRight: n(() => import("./TnIconopen-panel-right-BTuLLqj5.js")),
      TnIconOverflowMenuHorizontal: n(() => import("./TnIconoverflow-menu-horizontal-ryf2CPOg.js")),
      TnIconOverflowMenuVertical: n(() => import("./TnIconoverflow-menu-vertical-DDz7nm8j.js")),
      TnIconPaperclip: n(() => import("./TnIconpaperclip-CNMVz4bQ.js")),
      TnIconPasskey: n(() => import("./TnIconpasskey-DDqgvJuc.js")),
      TnIconPaste: n(() => import("./TnIconpaste-DuLxMc5c.js")),
      TnIconPause: n(() => import("./TnIconpause-BpKZqRuq.js")),
      TnIconPauseCircleOutline: n(() => import("./TnIconpause-circle-outline-BbZnQeFi.js")),
      TnIconPauseLarge: n(() => import("./TnIconpause-large-iVY_6XdO.js")),
      TnIconPendingCircleFilled: n(() => import("./TnIconpending-circle-filled-CFeyi7LK.js")),
      TnIconPendingCircleFlat: n(() => import("./TnIconpending-circle-flat--C_sXdK8.js")),
      TnIconPendingCircleOutline: n(() => import("./TnIconpending-circle-outline-DygxFf7z.js")),
      TnIconPeople: n(() => import("./TnIconpeople-D8TXwjBc.js")),
      TnIconPerson: n(() => import("./TnIconperson-CygEGrV3.js")),
      TnIconPhoneLandline: n(() => import("./TnIconphone-landline-CliBJqUI.js")),
      TnIconPhoneMobile: n(() => import("./TnIconphone-mobile-DVe8x3OO.js")),
      TnIconPhoneReceiver: n(() => import("./TnIconphone-receiver-DhGnkfj4.js")),
      TnIconPhoneReceiverFilled: n(() => import("./TnIconphone-receiver-filled-aGMIL1Zo.js")),
      TnIconPickUp: n(() => import("./TnIconpick-up-C7IyJkg2.js")),
      TnIconPictureInPictureIn: n(() => import("./TnIconpicture-in-picture-in-BjfCN5cr.js")),
      TnIconPictureinPictureOut: n(() => import("./TnIconpicturein-picture-out-YCvjzE6L.js")),
      TnIconPieChart: n(() => import("./TnIconpie-chart-BegTV0uk.js")),
      TnIconPlan: n(() => import("./TnIconplan-Bxzw0rlr.js")),
      TnIconPlay: n(() => import("./TnIconplay-C3m7v7rL.js")),
      TnIconPlayCircleOutline: n(() => import("./TnIconplay-circle-outline-CzmuCJJ7.js")),
      TnIconPlayFilled: n(() => import("./TnIconplay-filled-BBioIPLP.js")),
      TnIconPlayLarge: n(() => import("./TnIconplay-large-BKLcbEgD.js")),
      TnIconPlayOnBox: n(() => import("./TnIconplay-on-box-DRhfDZXc.js")),
      TnIconPlayOnFetch: n(() => import("./TnIconplay-on-fetch-B4uXE2Yb.js")),
      TnIconPlus: n(() => import("./TnIconplus-B0lPXJ3k.js")),
      TnIconPlusCircleFilled: n(() => import("./TnIconplus-circle-filled-Bx8CCdAy.js")),
      TnIconPlusCircleOutline: n(() => import("./TnIconplus-circle-outline-CSSthBh_.js")),
      TnIconPrinter: n(() => import("./TnIconprinter-Dn7_gHiM.js")),
      TnIconPushPinFilled: n(() => import("./TnIconpush-pin-filled-CwpZLsoe.js")),
      TnIconPushPinOutline: n(() => import("./TnIconpush-pin-outline-Cnu7D7Py.js")),
      TnIconQr: n(() => import("./TnIconqr-B-GK1rfo.js")),
      TnIconQuestion: n(() => import("./TnIconquestion-C2qhZTEp.js")),
      TnIconQuestionCircleFilled: n(() => import("./TnIconquestion-circle-filled-BmDFLVZx.js")),
      TnIconQuestionCircleOutline: n(() => import("./TnIconquestion-circle-outline-D06x2ml4.js")),
      TnIconQueue: n(() => import("./TnIconqueue-CF17XVZ8.js")),
      TnIconRadio: n(() => import("./TnIconradio-DoPRyCBL.js")),
      TnIconRadioButtonChecked: n(() => import("./TnIconradio-button-checked-BtQ_qjoH.js")),
      TnIconRadioButtonUnchecked: n(() => import("./TnIconradio-button-unchecked-8FQL0Rsj.js")),
      TnIconRec: n(() => import("./TnIconrec-rLoAfgJW.js")),
      TnIconReceipt: n(() => import("./TnIconreceipt-hXg9oeTu.js")),
      TnIconRecycle: n(() => import("./TnIconrecycle-BsmFFxsK.js")),
      TnIconRedo: n(() => import("./TnIconredo-0BTXQLc5.js")),
      TnIconRefresh: n(() => import("./TnIconrefresh-BtTGHu2I.js")),
      TnIconReload: n(() => import("./TnIconreload-B7E989ve.js")),
      TnIconRemove: n(() => import("./TnIconremove-C6CHMPTR.js")),
      TnIconRemoveCircleFilled: n(() => import("./TnIconremove-circle-filled-BFuhtnEE.js")),
      TnIconRemoveCircleOutline: n(() => import("./TnIconremove-circle-outline-CfGr6q5S.js")),
      TnIconResumeWatching: n(() => import("./TnIconresume-watching-CpXRXE1v.js")),
      TnIconRight: n(() => import("./TnIconright-cRMVgnpn.js")),
      TnIconRouter: n(() => import("./TnIconrouter-C1yeB3-x.js")),
      TnIconRouting: n(() => import("./TnIconrouting-BUBCgLIX.js")),
      TnIconSearch: n(() => import("./TnIconsearch-CnJ9dft3.js")),
      TnIconSecurity: n(() => import("./TnIconsecurity-LAOH_N-J.js")),
      TnIconSecurityAlert: n(() => import("./TnIconsecurity-alert-D07ZXgJD.js")),
      TnIconSecurityOff: n(() => import("./TnIconsecurity-off-DwC3t7Yh.js")),
      TnIconSecurityOn: n(() => import("./TnIconsecurity-on-122ZNO7U.js")),
      TnIconSend: n(() => import("./TnIconsend-obWjN9Wb.js")),
      TnIconSeries: n(() => import("./TnIconseries-CueX1Mdr.js")),
      TnIconSeriesArchive: n(() => import("./TnIconseries-archive-a9fekZDV.js")),
      TnIconService: n(() => import("./TnIconservice-CdBiPjM3.js")),
      TnIconServices: n(() => import("./TnIconservices-BzleZ4nS.js")),
      TnIconSettings: n(() => import("./TnIconsettings-BpyTbWU6.js")),
      TnIconSettingsComplex: n(() => import("./TnIconsettings-complex-zO51QBIJ.js")),
      TnIconShare: n(() => import("./TnIconshare-CCe_n-nZ.js")),
      TnIconShareContent: n(() => import("./TnIconshare-content-Da-zcClC.js")),
      TnIconShovel: n(() => import("./TnIconshovel-CW9ylake.js")),
      TnIconSim: n(() => import("./TnIconsim-ConqeZ7M.js")),
      TnIconSkipBack10s: n(() => import("./TnIconskip-back10s-BpDMhEWq.js")),
      TnIconSkipBackward15s: n(() => import("./TnIconskip-backward15s-BLmFo_Pr.js")),
      TnIconSkipBackward30s: n(() => import("./TnIconskip-backward30s-oc0a_8s-.js")),
      TnIconSkipForward: n(() => import("./TnIconskip-forward-l9vgdNNM.js")),
      TnIconSkipForward10s: n(() => import("./TnIconskip-forward10s-DovGEH0Q.js")),
      TnIconSkipForward15s: n(() => import("./TnIconskip-forward15s-CtoVWuXY.js")),
      TnIconSkipForward30s: n(() => import("./TnIconskip-forward30s-D_kqbrwR.js")),
      TnIconSkiptoNext: n(() => import("./TnIconskipto-next-DOEk1M_K.js")),
      TnIconSkiptoPrevious: n(() => import("./TnIconskipto-previous-Ut1wAbwt.js")),
      TnIconSlack: n(() => import("./TnIconslack-D0UVMkF7.js")),
      TnIconSlackNegative: n(() => import("./TnIconslack-negative-C1yoRnld.js")),
      TnIconSms: n(() => import("./TnIconsms-Vdn4Hd26.js")),
      TnIconSoftphoneConnected: n(() => import("./TnIconsoftphone-connected-BlsX5OYE.js")),
      TnIconSoftphoneDisconnected: n(() => import("./TnIconsoftphone-disconnected-zmMljsut.js")),
      TnIconSort: n(() => import("./TnIconsort-BROqWkch.js")),
      TnIconSortDown: n(() => import("./TnIconsort-down-DKdSEiS0.js")),
      TnIconSortFilled: n(() => import("./TnIconsort-filled-CG4oM18_.js")),
      TnIconSortHorizontal: n(() => import("./TnIconsort-horizontal-CB2X6gCC.js")),
      TnIconSortOutline: n(() => import("./TnIconsort-outline-mL_2bI1n.js")),
      TnIconSortUp: n(() => import("./TnIconsort-up-CrMai89-.js")),
      TnIconSoundWave: n(() => import("./TnIconsound-wave-zRhcUwUd.js")),
      TnIconSpaceBar: n(() => import("./TnIconspace-bar-BI6sfe3e.js")),
      TnIconSpeakerOff: n(() => import("./TnIconspeaker-off-CYXsdWqv.js")),
      TnIconSpeakerOn: n(() => import("./TnIconspeaker-on-CThzdYn-.js")),
      TnIconSpeed: n(() => import("./TnIconspeed-BxkZui2F.js")),
      TnIconSpinner: n(() => import("./TnIconspinner-DuycAHSw.js")),
      TnIconSplit: n(() => import("./TnIconsplit-A4r-qd3H.js")),
      TnIconSport: n(() => import("./TnIconsport-D997YFfR.js")),
      TnIconStarFilled: n(() => import("./TnIconstar-filled-AMCllh2S.js")),
      TnIconStarOutline: n(() => import("./TnIconstar-outline-rSWkGQWs.js")),
      TnIconStartOver: n(() => import("./TnIconstart-over-jqbDevrZ.js")),
      TnIconStop: n(() => import("./TnIconstop-BoA9P3oB.js")),
      TnIconStorage: n(() => import("./TnIconstorage-D32ffjdt.js")),
      TnIconStorybook: n(() => import("./TnIconstorybook-CjmD2h_k.js")),
      TnIconStorybookNegative: n(() => import("./TnIconstorybook-negative-DRrHLEiq.js")),
      TnIconSubdirectoryLeft: n(() => import("./TnIconsubdirectory-left-DCfEyLhI.js")),
      TnIconSubdirectoryRight: n(() => import("./TnIconsubdirectory-right-Dkiz_PrJ.js")),
      TnIconSubscription: n(() => import("./TnIconsubscription-C3f5bOVD.js")),
      TnIconSubtitles: n(() => import("./TnIconsubtitles-DWImt8ui.js")),
      TnIconSuccess: n(() => import("./TnIconsuccess-Cwp5ljaj.js")),
      TnIconSuccessCircleFilled: n(() => import("./TnIconsuccess-circle-filled-VCBocK_D.js")),
      TnIconSuccessCircleFlat: n(() => import("./TnIconsuccess-circle-flat-CUJ0qm3X.js")),
      TnIconSuccessCircleOutline: n(() => import("./TnIconsuccess-circle-outline-O-8bFqF4.js")),
      TnIconTableofContent: n(() => import("./TnIcontableof-content-DatjjYWy.js")),
      TnIconTag: n(() => import("./TnIcontag-fAbpCntu.js")),
      TnIconTagFilled: n(() => import("./TnIcontag-filled-cIzeZVAd.js")),
      TnIconTelegrafen: n(() => import("./TnIcontelegrafen-WRSyq9za.js")),
      TnIconTelegrafen1px: n(() => import("./TnIcontelegrafen1px-BSRGrsYJ.js")),
      TnIconTelenor: n(() => import("./TnIcontelenor-9tvIdi7g.js")),
      TnIconTelenorNegative: n(() => import("./TnIcontelenor-negative-Ch92fqSL.js")),
      TnIconTelmi: n(() => import("./TnIcontelmi-r2Jm7VaG.js")),
      TnIconThumbsDownFilled: n(() => import("./TnIconthumbs-down-filled-CyJGvSQe.js")),
      TnIconThumbsDownOutline: n(() => import("./TnIconthumbs-down-outline-Bt-aamrb.js")),
      TnIconThumbsUpFilled: n(() => import("./TnIconthumbs-up-filled-DBRZUlS8.js")),
      TnIconThumbsUpOutline: n(() => import("./TnIconthumbs-up-outline-CxusT2Hf.js")),
      TnIconTickets: n(() => import("./TnIcontickets-L_AgU58M.js")),
      TnIconTimer: n(() => import("./TnIcontimer-Bu54oySX.js")),
      TnIconToDo: n(() => import("./TnIconto-do-HS2eO3Gq.js")),
      TnIconTrafficCone: n(() => import("./TnIcontraffic-cone-DknjBOV3.js")),
      TnIconTrashcan: n(() => import("./TnIcontrashcan-HNobcfgy.js")),
      TnIconTrashcanOpen: n(() => import("./TnIcontrashcan-open-C0AY73nU.js")),
      TnIconTrendingDown: n(() => import("./TnIcontrending-down-nIUWVoXS.js")),
      TnIconTrendingStable: n(() => import("./TnIcontrending-stable-8UkcyFaQ.js")),
      TnIconTrendingUp: n(() => import("./TnIcontrending-up-mP6S15rX.js")),
      TnIconTv: n(() => import("./TnIcontv-CTsOlGRx.js")),
      TnIconTvArchive: n(() => import("./TnIcontv-archive-HFOglQbM.js")),
      TnIconTvGuide: n(() => import("./TnIcontv-guide-D9JEe5T0.js")),
      TnIconTWeBox: n(() => import("./TnIcont-we-box-CLjB4uPW.js")),
      TnIconTwitterLegacy: n(() => import("./TnIcontwitter-legacy-Cx1UBtNy.js")),
      TnIconUnavailable: n(() => import("./TnIconunavailable-uwNzSUaD.js")),
      TnIconUndo: n(() => import("./TnIconundo-BIVu3E6a.js")),
      TnIconUp: n(() => import("./TnIconup-BrtDJLEc.js")),
      TnIconUploadTray: n(() => import("./TnIconupload-tray-CsVTUyYA.js")),
      TnIconVideocameraOn: n(() => import("./TnIconvideocamera-on-s6JCSnIV.js")),
      TnIconVideoOnDemand: n(() => import("./TnIconvideo-on-demand-Cmy-FhKs.js")),
      TnIconViewCard: n(() => import("./TnIconview-card-D8DCJFr_.js")),
      TnIconViewHorizontalCard: n(() => import("./TnIconview-horizontal-card-CKeg3L2N.js")),
      TnIconViewList: n(() => import("./TnIconview-list-F0qZqHi8.js")),
      TnIconViewTable: n(() => import("./TnIconview-table-CfmDPWJo.js")),
      TnIconVipps: n(() => import("./TnIconvipps-BtucbPcA.js")),
      TnIconVippsApp: n(() => import("./TnIconvipps-app-DO-aHlZY.js")),
      TnIconVippsAppNegative: n(() => import("./TnIconvipps-app-negative-oe27wLrA.js")),
      TnIconVoicemail: n(() => import("./TnIconvoicemail-DsJ3MH0s.js")),
      TnIconWarningCircleFilled: n(() => import("./TnIconwarning-circle-filled-pE3LMksW.js")),
      TnIconWarningCircleFlat: n(() => import("./TnIconwarning-circle-flat-TN2d1AQM.js")),
      TnIconWarningCircleOutline: n(() => import("./TnIconwarning-circle-outline-BpyFcZ1v.js")),
      TnIconWatch: n(() => import("./TnIconwatch-x_YA8P7b.js")),
      TnIconWeeklyArchive: n(() => import("./TnIconweekly-archive-KN31YHH9.js")),
      TnIconWiFi: n(() => import("./TnIconwi-fi-CBM1A1W6.js")),
      TnIconWiFiHome: n(() => import("./TnIconwi-fi-home-DYzx5Er1.js")),
      TnIconWizard: n(() => import("./TnIconwizard-DLqHiatX.js")),
      TnIconX: n(() => import("./TnIconx-BCHLd6kB.js")),
      TnIconYouTube: n(() => import("./TnIconyou-tube-DuDQeH9O.js")),
      TnIconZoomIn: n(() => import("./TnIconzoom-in-Cb1xWyF-.js")),
      TnIconZoomOut: n(() => import("./TnIconzoom-out-HXIImNrQ.js"))
    }, m = e(() => {
      if (!o.name) return null;
      const i = Object.keys(r).find((c) => c.toLowerCase() === `tnicon${o.name.toLowerCase().replace(/-/g, "")}`);
      return i ? r[i] : null;
    });
    return (i, c) => (l(), T(a(m.value), {
      height: t.value,
      width: t.value,
      fill: i.color
    }, null, 8, ["height", "width", "fill"]));
  }
});
export {
  u as TnIcon
};
